var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 37,
    height: 37
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 20.75C24.0919 20.75 28.625 16.2169 28.625 10.625 28.625 5.03312 24.0919 0.5 18.5 0.5 12.9081 0.5 8.375 5.03312 8.375 10.625 8.37666 16.2162 12.9088 20.7483 18.5 20.75ZM27.5 23 23.626 23C20.3733 24.5001 16.6267 24.5001 13.374 23L9.5 23C4.52944 23 0.5 27.0294 0.5 32L0.5 33.125C0.500552 34.9887 2.01127 36.4994 3.875 36.5L33.125 36.5C34.9887 36.4994 36.4994 34.9887 36.5 33.125L36.5 32C36.5 27.0294 32.4706 23 27.5 23Z",
    stroke: "#000000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountUser);
export default __webpack_public_path__ + "static/media/account_user.bf12427f3b1b7f58333590480302356a.svg";
export { ForwardRef as ReactComponent };